import React from "react";
import { EditContactDetailsScreenWithBookingData } from "~/features/book-appointment/EditContactDetailsScreen";

const Component = () => {
  return <EditContactDetailsScreenWithBookingData />;
};

export default Component;
